//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sysRoles, sysUserRoleRelas, sysUserRoleRelas_relas, sysUsers_detail } from '@/apis/system'

export default {
    data() {
        //表單校驗
        const rules = {
            roleArray: [{ required: true, message: '請選擇角色！' }],
        };

        const form = {
            loginUsername: '',
            realname: '',
            roleArray: []
        };

        return {
            id: '',
            form,
            rules,
            spinning: true,
            config: {
                roles: [],
            },
            labelCol: { style: { width: '150px', }, },
            wrapperCol: { span: 14, },
        }
    },
    async mounted() {
        this.id = this.$route.params.id;
        await this.onPageConfig();
        if (this.id > 0) {
            await this.onPageLoad();
        }
        this.spinning = false;
    },
    methods: {
        async onPageConfig() {
            try {
                const res = await sysRoles({ roleId: '', roleName: '', pageNumber: 1, pageSize: 9999 });
                if (res.code == 0) {
                    this.config.roles = res.data.records;
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad() {
            try {
                const res = await sysUsers_detail(this.id);
                if (res.code == 0) {
                    const item = res.data || {};
                    const form = { ...this.form };
                    form.id = this.id;
                    form.loginUsername = item.loginUsername;
                    form.realname = item.realname;
                    this.form = form;

                    const userRoleRes = await sysUserRoleRelas({ userId: this.id, pageNumber: 1, pageSize: 999 });
                    if (userRoleRes.code == 0) {
                        this.form.roleArray = userRoleRes.data.records.map(item => item.roleId);
                    } else {
                        this.$message.error(res.msg);
                    }
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async handleFormValidate(e) {
            e.preventDefault();
            this.$refs.form.validate(async valid => {
                if (valid) {
                    await this.onSubmit();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async onSubmit() {
            try {
                this.spinning = true;
                const submitForm = {
                    ...this.form,
                };
                submitForm.sysUserId = this.id;
                submitForm.roleIdListStr = JSON.stringify(this.form.roleArray);
                const res = await sysUserRoleRelas_relas(submitForm);
                if (res.code == 0) {
                    this.$message.success('編輯完成');
                    this.$router.push('/security/account');
                }
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.spinning = false;
            }
        }
    }
}
